module.exports = __webpack_public_path__ + "img/pic11.ed3208c0.png";